import { createStore } from 'redux';

export const cecPageNo = "cec_pageno";
export const twaPageNo = "twa_pageno";
export const mbaPageNo = "mba_pageno";
export const schoolPageNo = "school_pageno";
export const collegePageNo = "college_pageno";


const initialState = {
    cecPageNo: 0,
    twaPageNo: 0,
    mbaPageNo: 0,
    schoolPageNo: 0,
    collegePageNo: 0
}

const teamPageReducer = (state = initialState, action) => {
    switch (action.type) {
        case "cec_pageno_increment": {
            state.cecPageNo++;
            return state;
        }
        case "cec_pageno_decrement": {
            state.cecPageNo--;
            return state;
        }
        case "twa_pageno_increment": {
            state.twaPageNo++;
            return state;
        }
        case "twa_pageno_decrement": {
            state.twaPageNo--;
            return state;
        }
        case "mba_pageno_increment": {
            state.mbaPageNo++;
            return state;
        }
        case "mba_pageno_decrement": {
            state.mbaPageNo--;
            return state;
        }
        case "school_pageno_increment": {
            state.schoolPageNo++;
            return state;
        }
        case "school_pageno_decrement": {
            state.schoolPageNo--;
            return state;
        }
        case "college_pageno_increment": {
            state.collegePageNo++;
            return state;
        }
        case "college_pageno_decrement": {
            state.collegePageNo--;
            return state;
        }
        default: {
            return state;
        }
    }
}

const store = createStore(teamPageReducer);

export default store;


// WEBPACK FOOTER //
// ./src/redux/store.js